import AgentRankingDashboard from "../../components/Air/KPi/Card";
import AdminLayout from "../../layout/AdminLayout";

const KPIRevenue = () => {
    return(
        <AdminLayout>
             <div>
                <AgentRankingDashboard/>
             </div>
        </AdminLayout>
    );
}
export default KPIRevenue;